.wishlists {
  --scrollbar-track-width: 0.5rem;
  --scrollbar-track-background: var(--neutral);

  composes: scrollbar from '@/stylesheets/scrollbar.module.css';
}

.selectWishlistModal {
  z-index: 5000;

  @media (min-width: 769px) {
    top: calc(100% + 0.5rem);
    right: 0;
    bottom: unset;
    left: unset;
    width: 100%;
    height: 16.375rem;
  }

  > .content {
    max-height: 70%;

    @media (min-width: 769px) {
      max-height: 100%;
    }
  }

  .header {
    display: flex;
    flex: 0 0 auto;
    justify-content: flex-start;
    align-items: center;
    margin: -0.25rem -0.375rem 1rem;

    @media (min-width: 769px) {
      display: none;
    }

    .headerImage {
      display: flex;
      flex: 0 0 auto;
      justify-content: center;
      align-items: center;
      width: 2.25rem;
      height: 2.25rem;
      margin-right: 0.5625rem;
      padding: 0.125rem;
      border: 0.0625rem solid var(--neutral-200);
      border-radius: 0.5rem;
      background: var(--neutral-50);

      img {
        width: 100%;
        height: 100%;
        border-radius: 0.375rem;
        object-fit: cover;
      }
    }

    .headerText {
      flex: 1 1 0;
      min-width: 0;
      padding: 0 1.625rem 0 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .close {
      align-self: flex-start;
      width: 2rem;
      height: 2rem;
      margin: -0.3125rem -0.3125rem 0 auto;

      @media (min-width: 769px) {
        display: none;
      }

      svg {
        max-width: 1.375rem;
        max-height: 1.375rem;
      }
    }
  }

  .wishlists {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin: -1rem -1.25rem 0;
    padding: 0.375rem 0.4375rem 0.25rem;
    overflow: auto;
    list-style: none;

    @media (min-width: 769px) {
      margin: -1rem -1.25rem 0;
      padding: 0.375rem 0.3125rem 0.125rem;
    }
  }

  .search {
    position: relative;
    margin: -1rem -1.25rem 1rem;
    padding: 1rem;
    border-bottom: 0.0625rem solid var(--neutral-200);

    @media (min-width: 769px) {
      padding: 0.875rem;
    }
  }

  .create,
  .wishlist,
  .everything {
    flex: 0 0 auto;

    .icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 1.5625rem;
      height: 1.5625rem;
    }

    .itemsCount {
      margin: 0 0 0 auto;
      padding: 0 1rem 0 2rem;
      font-variant-numeric: tabular-nums;
    }
  }

  .create,
  .wishlist {
    height: 2.75rem;

    @media (min-width: 769px) {
      height: 2.5rem;
    }

    &:last-child {
      margin-bottom: 0.25rem;
    }
  }

  .create,
  .everything {
    .icon {
      svg {
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }

  .create {
    .icon {
      margin: 0 0.5625rem 0 0.5rem;
    }
  }

  .wishlist {
    .icon {
      margin: 0 0.5rem 0 0.5rem;

      svg {
        width: 1.125rem;
        height: 1.125rem;
      }
    }
  }

  .everything {
    z-index: 50;
    height: 3.1875rem;
    margin: auto -1.25rem -1.25rem;
    padding: 0.3125rem 0.5rem 0.3125rem;
    border-top: 0.0625rem solid var(--neutral-200);
    background-color: var(--neutral);

    @media (min-width: 769px) {
      height: 3.0625rem;
      margin: auto -1.25rem -1.125rem;
      padding: 0.3125rem 0.3125rem 0.1875rem;
    }

    .icon {
      margin: 0 0.4375rem 0 0.5rem;
    }
  }

  .empty {
    max-width: 8rem;
    margin: auto;
    padding: 1rem 0;
    text-align: center;
  }
}
